<template>
  <v-container>
    <v-form class="px-3" ref="formProfileAll" @submit.prevent="submitProfile">
      <v-card flat class="my-4 mx-auto" max-width="1200px">
        <v-card-title class="font-weight-bold pa-8 text-h5 default-border"
          >Admin Data</v-card-title
        >
        <v-stepper v-model="e1" flat outlined>
          <v-stepper-header
            style="
              box-shadow: none;
              border-bottom: 2px solid rgba(0, 0, 0, 0.12);
            "
          >
            <v-stepper-step :complete="e1 > 1" step="1"
              >Feeder Profile</v-stepper-step
            >
            <v-divider></v-divider>
            <v-stepper-step :complete="e1 > 2" step="2"
              >Technology</v-stepper-step
            >
            <v-divider></v-divider>
            <v-stepper-step :complete="e1 > 3" step="3">VODER</v-stepper-step>
          </v-stepper-header>
          <v-stepper-items>
            <v-form
              class="px-3"
              ref="formProfile"
              @submit.prevent="submitProfile"
            >
              <v-stepper-content step="1">
                <v-card class="mx-auto" flat>
                  <v-expansion-panels class="default-border" flat>
                    <v-expansion-panel>
                      <v-expansion-panel-header class="font-weight-bold">
                        <v-row>
                          <v-col align-self="center"> Load Profile </v-col>
                          <v-col style="text-align: right">
                            <v-tooltip left>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  icon
                                  small
                                  fab
                                  @click="openNewSubstationWindow"
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  <v-icon>mdi-plus</v-icon>
                                </v-btn>
                              </template>
                              <span>Add Profile</span>
                            </v-tooltip>
                          </v-col>
                        </v-row>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <div class="pt-6">
                          Profile Type <Tooltips :Tooltip="selected === 'state_level' ? adminStateLevelTooltip : adminLoadProfileTooltip" />
                          <v-select
                            v-model="selected"
                            :items="profileType"
                            item-text="title"
                            item-value="value"
                          >
                          </v-select>
                          <div>
                            <FeederData
                              :loadProfiles="allLoadProfiles"
                              :profileType="selected"
                              :Loading="isLoadProfilesLoading"
                            />
                          </div>
                        </div>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>

                  <!-- <div class="mt-10">
                    <v-text class="font-weight-medium header" >Upload new feeder profile</v-text>
                    <v-file-input  label="File input" v-model="file" ></v-file-input>
                    <v-btn  text color="info" v-on:click="submitFile()">Load</v-btn>
                </div> -->

                  <!-- <Select class="mt-3" Lable="Feeder Type" DataSource='FeederType' @SelectedItem="setval"   :isRequired="true"/> -->

                  <v-expansion-panels class="default-border" flat>
                    <v-expansion-panel>
                      <v-expansion-panel-header class="font-weight-bold">
                        <v-row>
                          <v-col align-self="center"> Type of conductor </v-col>
                          <v-col style="text-align: right">
                            <v-tooltip left>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  v-bind="attrs"
                                  @click="openNewWindow"
                                  v-on="on"
                                  icon
                                  small
                                  fab
                                >
                                  <v-icon>mdi-plus</v-icon>
                                </v-btn>
                              </template>
                              <span>Add Conductor Type</span>
                            </v-tooltip>
                          </v-col>
                        </v-row>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <AdminConductorType
                          :projects="conductorTypes"
                          :Loading="isConductorTypesLoading"
                        />
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                  <div class="mt-10 mx-2">
                    <v-text-field
                      v-model="yearlyChangeInLoadPercent"
                      :rules="inputRules"
                      type="number"
                    >
                      <template v-slot:label>
                        Yearly change in load (%)
                        <span class="red--text">*</span>
                      </template>
                    </v-text-field>

                    <v-text-field
                      class="mt-3"
                      v-model="peakViolationCountForCapacityUpgradation"
                      :rules="inputRules"
                      type="number"
                    >
                      <template v-slot:label>
                        Instances of peak violation for capacity upgradation
                        <span class="red--text">*</span>
                      </template>
                    </v-text-field>
                    <v-text-field
                      v-model="minAcceptableVoltageDeviation"
                      :rules="inputRules"
                      type="number"
                    >
                      <template v-slot:label>
                        Min acceptable voltage deviation
                        <span class="red--text">*</span>
                      </template>
                    </v-text-field>
                    <v-text-field
                      v-model="maxAcceptableVoltageDeviation"
                      :rules="inputRules"
                      type="number"
                    >
                      <template v-slot:label>
                        Max acceptable voltage deviation
                        <span class="red--text">*</span>
                      </template>
                    </v-text-field>
                    <v-text-field
                      v-model="peakLoadHoursTimeFactor"
                      :rules="inputRules"
                      type="number"
                    >
                      <template v-slot:label>
                        Peak load hours time factor
                        <span class="red--text">*</span>
                      </template>
                    </v-text-field>
                  </div>
                </v-card>
                <v-card-actions class="justify-center">
                  <v-btn outlined color="primary" @click="submitProfile"
                    >Save</v-btn
                  >
                  <!-- <v-btn outlined color="primary" @click="e1 = 2">Next</v-btn> -->
                  <v-btn outlined color="primary" @click="tabOne">Next</v-btn>
                </v-card-actions>
              </v-stepper-content>
            </v-form>
            <v-form class="px-3" ref="formTech" @submit.prevent="submitTech">
              <v-stepper-content step="2">
                <v-card width="600" class="mx-auto" flat>
                  <v-card-text>
                    <v-text-field
                      v-model="yearlySolarDegradationFactor"
                      :rules="inputRules"
                      type="number"
                    >
                      <!-- <v-btn slot="append" outlined color="primary" >Change</v-btn> -->
                      <template v-slot:label>
                        Yearly solar degradation factor
                        <span class="red--text">*</span>
                      </template>
                    </v-text-field>
                    <v-text-field
                      v-model="storageRoundTripEfficiency"
                      :rules="inputRules"
                      type="number"
                    >
                      <!-- <v-btn slot="append" outlined color="primary" >Change</v-btn> -->
                      <template v-slot:label>
                        Storage round trip efficiency
                        <span class="red--text">*</span>
                      </template>
                    </v-text-field>
                    <v-text-field
                      v-model="depthOfDischarge"
                      :rules="inputRules"
                      type="number"
                    >
                      <!-- <v-btn slot="append" outlined color="primary" >Change</v-btn> -->
                      <template v-slot:label>
                        Depth of discharge
                        <span class="red--text">*</span>
                      </template>
                    </v-text-field>
                    <v-text-field
                      v-model="inverterEfficiency"
                      :rules="inputRules"
                      type="number"
                    >
                      <!-- <v-btn slot="append" outlined color="primary" >Change</v-btn> -->
                      <template v-slot:label>
                        Inverter efficiency
                        <span class="red--text">*</span>
                      </template>
                    </v-text-field>
                    <v-text-field
                      v-model="storageCycleLife"
                      :rules="inputRules"
                      type="number"
                    >
                      <!-- <v-btn slot="append" outlined color="primary" >Change</v-btn> -->
                      <template v-slot:label>
                        Storage cycle life
                        <span class="red--text">*</span>
                      </template>
                    </v-text-field>
                  </v-card-text>
                </v-card>
                <v-card-actions class="justify-center">
                  <v-btn outlined color="primary" @click="e1 = 1">Back</v-btn>
                  <v-btn outlined color="primary" @click="submitProfile"
                    >Save</v-btn
                  >
                  <!-- <v-btn outlined color="primary" @click="e1 = 3">Next</v-btn> -->
                  <v-btn outlined color="primary" @click="tabTwo">Next</v-btn>
                </v-card-actions>
              </v-stepper-content>
            </v-form>
            <!--  <v-form class="px-3" ref="formVoder" @submit.prevent="submitVoder"> -->
            <v-stepper-content step="3">
              <v-card max-width="800" class="mx-auto" flat>
                <v-expansion-panels class="default-border" flat>
                  <v-expansion-panel flat>
                    <v-expansion-panel-header class="font-weight-bold">
                      <v-row>
                        <v-col align-self="center" width="500px">
                          Marginal cost of energy to be replaced(INR/kWh)<Tooltips :Tooltip="adminMarginalCostOfEnergy" />
                        </v-col>
                        <div style="text-align: right; padding-right: 15px; padding-top: 5px;">
                          <v-tooltip left>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                icon
                                small
                                fab
                                @click="openNewMarginWindow"
                                v-bind="attrs"
                                v-on="on"
                              >
                                <v-icon>mdi-plus</v-icon>
                              </v-btn>
                            </template>
                            <span>Add Marginal cost of energy</span>
                          </v-tooltip>
                        </div>
                      </v-row>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <DataTable
                        :projects="marginalCostOfReplacedEnergyRecords"
                        source="marginalCostOfReplacedEnergyRecords"
                        :Loading="isMarginalCostEnergyLoading"
                        :headers="marginaCostHeaders"
                      />
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
                <div>
                  <v-card-text>
                    <v-text-field
                      v-model="analysisPeriodYears"
                      :rules="inputRules"
                      type="number"
                    >
                      <template v-slot:label>
                        Analysis period (years)
                        <span class="red--text">*</span>
                      </template>
                    </v-text-field>

                    <v-text-field
                      v-model="discountFactor"
                      :rules="inputRules"
                      type="number"
                    >
                      <template v-slot:label>
                        Discount Factor (%)
                        <span class="red--text">*</span>
                      </template>
                    </v-text-field>

                    <v-text-field
                      v-model="upgradationCapacityUpperLimit"
                      :rules="inputRules"
                      type="number"
                    >
                      <template v-slot:label>
                        Upper limit for capacity upgradation (%)
                        <span class="red--text">*</span>
                      </template>
                    </v-text-field>
                    <v-text-field
                      v-model="loadShiftedAfterUpgradationPercent"
                      :rules="inputRules"
                      type="number"
                    >
                      <template v-slot:label>
                        Percentage of load shifted after upgradation
                        <span class="red--text">*</span>
                      </template>
                    </v-text-field>
                    <v-text-field
                      v-model="transmissionCapacityCostINR_MW"
                      :rules="inputRules"
                      type="number"
                    >
                      <template v-slot:label>
                        Transmission capacity cost (INR/MW)
                        <span class="red--text">*</span>
                      </template>
                    </v-text-field>
                    <v-text-field
                      v-model="generationCapacityCostINR_MW"
                      :rules="inputRules"
                      type="number"
                    >
                      <template v-slot:label>
                        Generation capacity cost (INR/MW)
                        <span class="red--text">*</span>
                      </template>
                    </v-text-field>
                  </v-card-text>
                  <v-card-title>Emission rates</v-card-title>
                  <v-card-text>
                    <v-text-field
                      v-model="emissionRateCo2"
                      :rules="inputRules"
                      type="number"
                    >
                      <template v-slot:label>
                        Co2
                        <span class="red--text">*</span>
                      </template>
                    </v-text-field>
                    <v-text-field
                      v-model="emissionRateNo2"
                      :rules="inputRules"
                      type="number"
                    >
                      <template v-slot:label>
                        No2
                        <span class="red--text">*</span>
                      </template>
                    </v-text-field>

                    <v-text-field
                      v-model="emissionRateSo2"
                      :rules="inputRules"
                      type="number"
                    >
                      <template v-slot:label>
                        So2
                        <span class="red--text">*</span>
                      </template>
                    </v-text-field>

                    <v-text-field
                      v-model="emissionRateSPM2_5"
                      :rules="inputRules"
                      type="number"
                    >
                      <template v-slot:label>
                        SPM2.5
                        <span class="red--text">*</span>
                      </template>
                    </v-text-field>
                  </v-card-text>
                  <v-card-title>Emission costs</v-card-title>
                  <v-card-text>
                    <v-text-field
                      v-model="emissionCostCo2"
                      :rules="inputRules"
                      type="number"
                    >
                      <template v-slot:label>
                        Cost of Co2
                        <span class="red--text">*</span>
                      </template>
                    </v-text-field>
                    <v-text-field
                      v-model="emissionCostNo2"
                      :rules="inputRules"
                      type="number"
                    >
                      <template v-slot:label>
                        Cost of No2
                        <span class="red--text">*</span>
                      </template>
                    </v-text-field>
                    <v-text-field
                      v-model="emissionCostSo2"
                      :rules="inputRules"
                      type="number"
                    >
                      <template v-slot:label>
                        Cost of So2
                        <span class="red--text">*</span>
                      </template>
                    </v-text-field>
                    <v-text-field
                      v-model="emissionCostSPM2_5"
                      :rules="inputRules"
                      type="number"
                    >
                      <template v-slot:label>
                        Cost of PM2.5
                        <span class="red--text">*</span>
                      </template>
                    </v-text-field>
                  </v-card-text>
                </div>
              </v-card>
              <v-card-actions class="justify-center">
                <v-btn outlined color="primary" @click="e1 = 2">Back</v-btn>
                <v-btn outlined color="primary" @click="submitProfile"
                  >Save</v-btn
                >
                <v-btn outlined color="primary" :disabled="true">Next</v-btn>
              </v-card-actions>
            </v-stepper-content>
            <!-- </v-form>    -->
          </v-stepper-items>
        </v-stepper>
        <NewEditConductorType
          :visible="showNewConductorWindow"
          @close="closeWindow"
          :EditMode="false"
        />

        <NewEditSubstationProfile
          :visible="showNewSubstationWindow"
          @close="closeWindow"
          WindowLable="Load Profile"
          :EditMode="false"
        />
        <NewEditMarginCostReplaced
          :visible="showNewMarginWindow"
          @close="closeWindow"
          WindowLable="New Marginal Cost Of Replaced Energy"
          :EditMode="false"
        />
      </v-card>
    </v-form>
  </v-container>
</template>
<script>
import FeederData from "@/components/adminfeederprofile.vue";
import DataTable from "@/components/DataTable";
import AdminConductorType from "@/components/conductortype.vue";
import AdminFeederStore from "@/services/adminfeederstore.js";

import dataService from "@/libs/dataService";
import staticMasterdataService from "@/libs/staticMasterData";
import loadProfileService from "@/libs/loadProfileService";
import masterConstantsService from "@/libs/masterConstantsService";

import NewEditConductorType from "@/components/newEditConductorType.vue";
import NewEditSubstationProfile from "@/components/newEditSubstationProfile.vue";
import NewEditMarginCostReplaced from "@/components/newEditMarginalCost.vue";
import Tooltips from "@/components/tooltips.vue";
import { bus } from "../main";

export default {
  name: "Admin",
  components: {
    // Select,
    FeederData,
    DataTable,
    AdminConductorType,
    NewEditConductorType,
    NewEditSubstationProfile,
    NewEditMarginCostReplaced,
    Tooltips
  },
  data() {
    return {
      marginaCostHeaders: [
        {
          text: "Name",
          align: "start",
          sortable: false,
          value: "title",
          width: "30%",
        },
        { text: "Last Updated", value: "_updated", width: "24%" },
        {
          text: "Published",
          value: "isPublished",
          width: "18%",
          align: "center",
        },
        {
          text: "Edit",
          value: "ModifyMarginalCost",
          width: "7%",
          align: "center",
          sortable: false,
        },
        {
          text: "Delete",
          value: "delete",
          width: "7%",
          align: "center",
          sortable: false,
        },
        {
          text: "Publish/Unpublish",
          value: "_isPublished",
          width: "7%",
          align: "center",
          sortable: false,
        },
        {
          text: "Download",
          value: "Download",
          width: "7%",
          align: "center",
          sortable: false,
        },
      ],

      selected: "dt",
      step: "",
      e1: 1,
      EditMode: false,
      tabOneMessage: "",
      tabTwoMessage: "",
      tabThreeMessage: "",
      tabFourMessage: "",
      masterConstants: [],
      allLoadProfiles: [],
      conductorTypes: [],
      SubstationProfileData: [],
      Statelevelloadprofile: [],
      marginalCostOfReplacedEnergyRecords: [],
      showNewConductorWindow: false,
      showNewSubstationWindow: false,
      showNewMarginWindow: false,
      feedertype: "",
      yearlyChangeInLoadPercent: "",
      peakViolationCountForCapacityUpgradation: "",
      minAcceptableVoltageDeviation: "",
      maxAcceptableVoltageDeviation: "",
      peakLoadHoursTimeFactor: "",
      yearlySolarDegradationFactor: "",
      storageRoundTripEfficiency: "",
      depthOfDischarge: "",
      inverterEfficiency: "",
      storageCycleLife: "",
      analysisPeriodYears: "",
      discountFactor: "",
      upgradationCapacityUpperLimit: "",
      loadShiftedAfterUpgradationPercent: "",
      transmissionCapacityCostINR_MW: "",
      generationCapacityCostINR_MW: "",
      overhead: "",
      underground: "",
      discountfactor: "",
      emissionRateCo2: "",
      emissionRateSo2: "",
      emissionRateNo2: "",
      emissionRateSPM2_5: "",
      emissionCostCo2: "",
      emissionCostSo2: "",
      emissionCostNo2: "",
      emissionCostSPM2_5: "",

      errorMsg: "",
      loading: false,
      timeout: 5000,
      Notification: false,
      color: "red",
      inputRules: [(v) => !!v || "This field is required"],
      profileType: [],
      isLoadProfilesLoading: false,
      isConductorTypesLoading: false,
      isMarginalCostEnergyLoading: false,
      adminLoadProfileTooltip:`* Upload file must contain two columns with title as 'date' & 'value' respectively \n* 'date' column format 'DD-MM-YYYY HH:MM'  \n* 'value' column should be in 'MW'  \n* Only 8760 data points are accepted`,
      adminStateLevelTooltip : `* Upload file must contain two columns with title as 'date' & 'value' respectively  \n* 'date' column format 'DD-MM-YYYY HH:MM' \n* 'value' column should be in 'MW' \n* Please upload a net load profile (Net load is the total electric demand minus wind and solar generation). \n* Note: In case the analysis is carried out without a net load profile, the resulting avoided generation capacity cost (AGCC) and avoided transmission capacity cost (ATCC) will be overestimated. \n* Only 8760 data points are accepted \n\t\t\t\t\t\t\t\t(Or)\n * Enter a peak load demand in MW for a given date and time`,
      adminMarginalCostOfEnergy:`* 'Cost of supply hourly data (8760)' (or) 'IEX hourly data (8760)' (or) 'Cost of supply (or) energy cost (single)' \n* Upload file must contain two columns with title as 'date' & 'value' respectively \n* 'date' column format 'DD-MM-YYYY HH:MM' \n* 'value' column should be in 'MW' \n* Only 8760 data points are accepted`,
    };
  },
  async mounted() {
    var _id = "NA";
    const masterConstants =
      await AdminFeederStore.methods.getAllMasterConstant();
    this.masterConstants = masterConstants[masterConstants.length - 1];
    _id = masterConstants[masterConstants.length - 1]._id;
    this.loading = true;
    if (_id !== "NA") {
      this.fillMasterConstants();
    }
  },
  created() {
    this.fillDatatable();
    this.fillProfileTypes();
    this.EditMode = true;
  },

  methods: {
    fillProfileTypes() {
      this.profileType = staticMasterdataService.getProfileTypes();
    },
    saveAction(payload, _status, statusMessage) {
      bus.$emit("SaveNotification", _status, statusMessage);
      if (_status === "OK") {
        bus.$emit("justAddedProfileRecord", payload);
        this.$refs.form.reset();
        this.show = false;
      }
    },
    upodateAction(payload, _status, statusMessage) {
      bus.$emit("updateNotification", _status, statusMessage);
      if (_status === "OK") {
        bus.$emit("justEditedProfileRecord", payload);
        this.$refs.form.reset();
        this.show = false;
      }
    },

    fillMasterConstants() {
      if (this.masterConstants) {
        this.yearlyChangeInLoadPercent =
          this.masterConstants.yearlyChangeInLoadPercent;
        this.peakViolationCountForCapacityUpgradation =
          this.masterConstants.peakViolationCountForCapacityUpgradation;
        this.minAcceptableVoltageDeviation =
          this.masterConstants.minAcceptableVoltageDeviation;
        this.maxAcceptableVoltageDeviation =
          this.masterConstants.maxAcceptableVoltageDeviation;
        this.yearlySolarDegradationFactor =
          this.masterConstants.technologyConstants.yearlySolarDegradationFactor;
        this.storageRoundTripEfficiency =
          this.masterConstants.technologyConstants.storageRoundTripEfficiency;
        this.depthOfDischarge =
          this.masterConstants.technologyConstants.depthOfDischarge;
        this.inverterEfficiency =
          this.masterConstants.technologyConstants.inverterEfficiency;
        this.storageCycleLife =
          this.masterConstants.technologyConstants.storageCycleLife;
        this.peakLoadHoursTimeFactor =
          this.masterConstants.peakLoadHoursTimeFactor;
        this.analysisPeriodYears = this.masterConstants.analysisPeriodYears;
        this.discountFactor = this.masterConstants.discountFactor;
        this.upgradationCapacityUpperLimit =
          this.masterConstants.upgradationCapacityUpperLimit;
        this.loadShiftedAfterUpgradationPercent =
          this.masterConstants.loadShiftedAfterUpgradationPercent;
        this.transmissionCapacityCostINR_MW =
          this.masterConstants.transmissionCapacityCostINR_MW;
        this.generationCapacityCostINR_MW =
          this.masterConstants.generationCapacityCostINR_MW;

        const { emissionRates, emissionCosts } = this.masterConstants;
        this.emissionRateCo2 = emissionRates.emissionRateCo2;
        this.emissionRateNo2 = emissionRates.emissionRateNo2;
        this.emissionRateSo2 = emissionRates.emissionRateSo2;
        this.emissionRateSPM2_5 = emissionRates.emissionRateSPM2_5;
        this.emissionCostCo2 = emissionCosts.emissionCostCo2;
        this.emissionCostNo2 = emissionCosts.emissionCostNo2;
        this.emissionCostSo2 = emissionCosts.emissionCostSo2;
        this.emissionCostSPM2_5 = emissionCosts.emissionCostSPM2_5;
      }
    },
    openNewWindow() {
      this.showNewConductorWindow = true;
    },
    openNewSubstationWindow() {
      this.showNewSubstationWindow = true;
    },
    openNewMarginWindow() {
      this.showNewMarginWindow = true;
    },
    closeWindow() {
      this.showNewConductorWindow = false;
      this.showNewSubstationWindow = false;
      this.showNewMarginWindow = false;
    },
    tabOne() {
      if (this.$refs.formProfile.validate()) {
        this.e1 = 2;
      }
    },
    tabTwo() {
      if (this.$refs.formTech.validate()) {
        this.e1 = 3;
      }
    },

    fillDatatable() {
      this.getLoadProfiles();
      this.getConductorTypeList();
      this.getMarginalCost();
    },

    getLoadProfiles() {
      this.isLoadProfilesLoading = true;
      loadProfileService.getLoadProfiles().then((res) => {
        this.allLoadProfiles = res.data._items;
        this.isLoadProfilesLoading = false;
      });
    },

    getMarginalCost() {
      this.isMarginalCostEnergyLoading = true;
      dataService.list("marginalCostOfReplacedEnergyRecords").then((res) => {
        this.marginalCostOfReplacedEnergyRecords = res;
        this.isMarginalCostEnergyLoading = false;
      });
    },
    getConductorTypeList() {
      this.isConductorTypesLoading = true;
      dataService.list("conductorTypes").then((res) => {
        this.conductorTypes = res;
        this.isConductorTypesLoading = false;
      });
    },
    // setval(e) {
    //   if (e.datasource === "FeederType") {
    //     this.feedertype = e.value;
    //   }
    // },
    async getCurrentMasterConstantId() {
      const res = await masterConstantsService.getAllMasterConstants();
      const constants = res.data._items;
      if (constants && constants.length > 0) {
        return constants[0]._id;
      }
      return null;
    },
    async submitProfile() {
      if (this.$refs.formProfileAll.validate()) {
        const id = await this.getCurrentMasterConstantId();
        this.loading = true;
        const payload = {
          yearlyChangeInLoadPercent: this.yearlyChangeInLoadPercent,
          peakViolationCountForCapacityUpgradation:
            this.peakViolationCountForCapacityUpgradation,
          minAcceptableVoltageDeviation: this.minAcceptableVoltageDeviation,
          maxAcceptableVoltageDeviation: this.maxAcceptableVoltageDeviation,
          technologyConstants: {
            yearlySolarDegradationFactor: this.yearlySolarDegradationFactor,
            storageRoundTripEfficiency: this.storageRoundTripEfficiency,
            depthOfDischarge: this.depthOfDischarge,
            inverterEfficiency: this.inverterEfficiency,
            storageCycleLife: this.storageCycleLife,
          },
          peakLoadHoursTimeFactor: this.peakLoadHoursTimeFactor,
          analysisPeriodYears: this.analysisPeriodYears,
          discountFactor: this.discountFactor,
          upgradationCapacityUpperLimit: this.upgradationCapacityUpperLimit,
          loadShiftedAfterUpgradationPercent:
            this.loadShiftedAfterUpgradationPercent,
          transmissionCapacityCostINR_MW: this.transmissionCapacityCostINR_MW,
          generationCapacityCostINR_MW: this.generationCapacityCostINR_MW,
          emissionRates: {
            emissionRateCo2: this.emissionRateCo2,
            emissionRateNo2: this.emissionRateNo2,
            emissionRateSo2: this.emissionRateSo2,
            emissionRateSPM2_5: this.emissionRateSPM2_5,
          },
          emissionCosts: {
            emissionCostCo2: this.emissionCostCo2,
            emissionCostNo2: this.emissionCostNo2,
            emissionCostSo2: this.emissionCostSo2,
            emissionCostSPM2_5: this.emissionCostSPM2_5,
          },
        };
        if (id === null) {
          masterConstantsService
            .addMasterConstants(payload)
            .then(() => {
              bus.$emit("SaveNotification", "OK", "", "Admin profile");
            })
            .catch((error) => {
              bus.$emit("SaveNotification", 400, error, "Admin profile");
            });
        } else {
          payload["_id"] = id;
          masterConstantsService
            .updateMasterConstants(id, payload)
            .then(() => {
              bus.$emit("updateNotification", "OK", "", "Admin profile");
            })
            .catch((error) => {
              bus.$emit("updateNotification", 400, error, "Admin profile");
            });
        }
      } else {
        console.log("form error");
      }
    },
  },
};
</script>
<style scoped>
.v-expansion-panel-header {
  background-color: #f5f5f5;
}
.default-border {
  border: 1px solid rgba(0, 0, 0, 0.12);
}
</style>
